import {TableBody, TableCell, TableRow} from '@material-ui/core';
import React, {useEffect, useState} from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import InputText from '../../../../components/forms/InputText';

const EditListItem = ({users, editable, setUsers}) => {
  const updateEmail = (id, value) => {
    setUsers(prevState => {
      return [
        ...prevState.map((a, index) => {
          if (index === id) {
            return {...a, Email: value};
          }
          return a;
        }),
      ];
    });
  };

  const updateNome = (id, value) => {
    setUsers(prevState => {
      return [
        ...prevState.map((a, index) => {
          if (index === id) {
            return {...a, Nome: value};
          }
          return a;
        }),
      ];
    });
  };

  const deleteItem = id => {
    const usersFilter = users.filter((item, index) => index != id);
    setUsers(usersFilter);
  };

  useEffect(() => {
    if (!editable) {
      const usersFilter = users.filter(item => item.Nome || item.Email);
      setUsers(usersFilter);
    }
  }, [editable]);

  return (
    <TableBody>
      {users.length ? (
        editable ? (
          <>
            {users.map((user, index) => (
              <TableRow key={index}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>
                  <InputText
                    label=""
                    value={users[index].Nome}
                    onChange={e => updateNome(index, e.target.value.toString())}
                  />
                </TableCell>
                <TableCell>
                  <InputText
                    label=""
                    value={users[index].Email}
                    onChange={e =>
                      updateEmail(index, e.target.value.toString())
                    }
                  />
                </TableCell>
              </TableRow>
            ))}
          </>
        ) : (
          users.map((user, index) => (
            <TableRow key={index}>
              <TableCell>{index + 1}</TableCell>
              <TableCell>{user.Nome}</TableCell>
              <TableCell>{user.Email}</TableCell>
              <TableCell
                style={{
                  cursor: 'pointer',
                }}
                onClick={() => deleteItem(index)}>
                <DeleteIcon />
              </TableCell>
            </TableRow>
          ))
        )
      ) : (
        <TableRow>
          <td colSpan="5" className="text-center">
            Sem dados.
          </td>
        </TableRow>
      )}
    </TableBody>
  );
};

export default EditListItem;
